import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { DirectDebitPaymentModel } from '@shared/data-access/models';
import { filter, Observable, take, tap } from 'rxjs';
import { DirectDebitPaymentAction } from '../actions';
import { DirectDebitPaymentReducer } from '../reducers';
import { DirectDebitPaymentSelector } from '../selectors';

@Injectable()
export class DirectDebitPaymentFacade {
  selectedItem$ = this._store.select(DirectDebitPaymentSelector.selectDirectDebitPayment);
  selectedLoadingItem$ = this._store.select(DirectDebitPaymentSelector.selectLoadingItem);

  constructor(private _store: Store<DirectDebitPaymentReducer.DirectDebitPaymentState>) { }

  /**
   * Get @DirectDebitPaymentModel by id
   */
  getById(id: number): Observable<DirectDebitPaymentModel | null> {
    this.loading(true);
    this._store.dispatch(DirectDebitPaymentAction.loadItem({ id }));
    return this.selectedItem$.pipe(
      tap((e) => !e && this.loading(false)),
      filter(val => !!val && val.id === id),
      take(1)
    ) as Observable<DirectDebitPaymentModel | null>;
  }

  loading(isLoading: boolean) {
    this._store.dispatch(DirectDebitPaymentAction.loadingItem({ isLoading }));
  }
}
